import { ShieldCheck, AlertTriangle } from "lucide-react";

export default function AnswerMeta({ message }) {
  const { model_label, auto, grounded } = message;
  if (!model_label && grounded == null) return null;
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      {model_label && (
        <span data-testid="answer-model" className="font-mono-label border border-border px-2 py-1 text-muted-foreground">
          {auto ? "Auto → " : ""}{model_label}
        </span>
      )}
      {grounded != null && (grounded >= 0.6 ? (
        <span data-testid="grounded-badge" className="font-mono-label px-2 py-1 border border-primary/30 text-primary inline-flex items-center gap-1">
          <ShieldCheck className="w-3.5 h-3.5" /> Backed by the document
        </span>
      ) : (
        <span data-testid="grounded-badge" className="font-mono-label px-2 py-1 border border-amber-500/50 bg-amber-50 text-amber-800 inline-flex items-center gap-1">
          <AlertTriangle className="w-3.5 h-3.5" /> May not be backed by the document — check the sources
        </span>
      ))}
    </div>
  );
}
